import React from 'react'
// import {Link} from 'react-router-dom'
import './style.css'
// import LocationMap from '../LocationModal/LocationModal'

const Welcome = () =>{
    return(
        <div className="welcome-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="welcome-content">
                        <h2 className="font-c">Welcome to our moment!</h2>
                        <br/>
                            <h2>Σας προσκαλούμε στον γάμο μας.</h2>
                            <p>
Θα χαρούμε πολύ να είστε κοντά μας σε αυτή την ξεχωριστή μέρα. Σας περιμένουμε όλους με αγάπη και χαρά.
                            </p>
                            <div class="d-flex justify-content-center gap-3">
                            {/* <div className="btn-w"><a href='#rsvp'>RSVP</a></div> */}
                            <div className="btn-w"><a href='#event'>EVENTS</a></div>
                            </div>
                            {/* <LocationMap buttonClass={'location-btn'} /> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Welcome;